import type { CoreConsentsResponse } from "@tandemdiabetes/sugarmate-api-react-client"
import { useGetPendingCoreConsents } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import useSWR from "swr"
import { usePendingConsentsSWRKey } from "./usePendingConsentsSWRKey"

export const usePendingConsents = () => {
  const pendingConsentsSWRKey = usePendingConsentsSWRKey()
  const getPendingConsents = useGetPendingCoreConsents()

  const getPendingConsentsData = useMemo(
    () => !getPendingConsents
      ? null
      : async () => {
        const response = await getPendingConsents()
        return response.data
      },
    [getPendingConsents],
  )

  return useSWR<CoreConsentsResponse>(
    pendingConsentsSWRKey,
    getPendingConsentsData,
  )
}
